import * as React from "react";

const SvgIcnMonitorOffLarge = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M13.229 3.071c.107.054.19.13.251.23.06.1.09.21.09.33V20.36c0 .12-.03.23-.09.33a.597.597 0 01-.251.23.447.447 0 01-.14.06.543.543 0 01-.331-.01.6.6 0 01-.172-.09l-6.428-5.043h-2.13c-.548 0-1.017-.17-1.405-.51-.389-.34-.583-.75-.583-1.23L2 9.875c0-.48.194-.888.583-1.221.388-.334.857-.5 1.406-.5h2.129l6.468-5.043a.6.6 0 01.322-.11.572.572 0 01.321.07zm-.944 16.15V4.84L6.68 9.34a.6.6 0 01-.361.12h-2.33c-.215 0-.385.047-.513.14-.127.095-.19.195-.19.302l.04 4.239c0 .107.063.21.19.311.128.1.299.15.513.15h2.33c.067 0 .13.007.19.02.061.014.118.041.172.081l5.564 4.52zM20.696 9.912L18.608 12l2.088 2.088a.43.43 0 11-.608.608L18 12.608l-2.088 2.088a.43.43 0 11-.608-.608L17.392 12l-2.088-2.088a.43.43 0 11.608-.608L18 11.392l2.088-2.088a.43.43 0 11.608.608z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnMonitorOffLarge;
